import {
  SelectField,
  type SelectFieldProps,
} from '@/components/form/SelectField';
import type { GenderOptionsType } from '@/hooks/useGenderOptions';
import { useGenderOptions } from '@/hooks/useGenderOptions';
import { useTranslation } from '@/i18n';
import type { FieldValues, Path } from 'react-hook-form';

type GenderFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>,
> = Omit<SelectFieldProps<TFieldValues, TName>, 'options' | 'aria-label'> & {
  genderOptionsType?: GenderOptionsType;
};

export const GenderField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>,
>({
  genderOptionsType,
  ...props
}: GenderFieldProps<TFieldValues, TName>) => {
  const { t } = useTranslation();
  const options = useGenderOptions(genderOptionsType);

  return (
    <SelectField {...props} options={options} aria-label={t('text.gender')} />
  );
};

GenderField.displayName = 'GenderField';
